import { auth } from "../index";
import { onAuthStateChanged, getAuth } from "firebase/auth"
import {createContext, useState} from "react";
import {
  savesignin
} from "../api/customerapi";
import { jwtDecode } from "jwt-decode";
import {url} from "../api/customerapi"


export const AuthContext = createContext();

const AuthContextProvider = (props) => {

    const [User, setUser]=useState(auth.currentUser)
    //console.log(User)
  const currenturl = window.location.href;
  const urlarray = currenturl.split("?token=");
  //console.log(urlarray)
  var token=""
  if(urlarray.length>1){
  token = urlarray[urlarray.length - 1];

  //console.log(token)
  }else{
    token = localStorage.getItem("jwtToken");
    //console.log(token)
  }

  // useEffect(() => {
//   // console.log(window.location.search)
//   console.log(auth)
//   // const urlParams = new URLSearchParams(window.location.search);
//   // console.log(urlParams)
//   // const token = urlParams.get('token');
//   console.log(token)
//   // const expiresAt = urlParams.get('expiresAt');
  if (token && User==null) {
    try {
        // Decode the token (no need to verify it here, just decoding to extract user info)
       

        
        async function verify(token){
          const response = await fetch(url+'/verifytoken', {
            method: 'POST',
            body: JSON.stringify({ token }),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        console.log(response)
        if (response.ok) {
            const userData = await response.json();
            // Set the user data in the app (e.g., in the state or localStorage)
            console.log('User authenticated:', userData);
            setUser(userData);
            localStorage.setItem("jwtToken", token);
            // window.location = ("/home");
        } else {
            setUser("abc");
            localStorage.clear();
            window.location = "/";
            throw new Error('Invalid token');
            
        }
        }

        const decodedToken = jwtDecode(token);

        // Check if token is still valid (you can also verify the token with the backend if needed)
        const currentTime = Math.floor(Date.now() / 1000);
        if (decodedToken.exp < currentTime) {
            throw new Error('Token has expired');
        }else{
          verify(token)
        }
        // Automatically log in the user
        // Assuming you have a backend endpoint to authenticate the user with the token
       
    } catch (error) {
        console.error('Authentication failed:', error);
    }
} else {
    if(User){

    }else{
    console.log('No token found in URL');
    const newauth = getAuth();
 
    onAuthStateChanged(auth, async(user) => {
        if (user) {
          // User is signed in, see docs for a list of available properties
          // https://firebase.google.com/docs/reference/js/firebase.User
          //console.log(auth.currentUser)
          setUser(auth.currentUser);
          
          
          
        } else {
          setUser("abc");
          //console.log(User)
      }});
    }
}
// }, []);
    

      // newauth.onAuthStateChanged(async (user) => {
      //   if (user) {
      //     // console.log(user)
      //     console.log(user.metadata.lastSignInTime)
      //     const data=await savesignin(user.email, user.metadata.lastSignInTime)
      //   }
      // });


    return (  
        <AuthContext.Provider value={{User}}>
            {props.children}
        </AuthContext.Provider>
    );
}
 
export default AuthContextProvider;